import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_PERSONNELTRAINING_LOAD_BY_ID,
    ACTION_PERSONNELTRAINING_CREATE,
    ACTION_PERSONNELTRAINING_SAVE,
    ACTION_PERSONNELTRAINING_VALIDATE,

    IPersonnelTrainingLoadByIdAction,
    IPersonnelTrainingLoadFailureAction,
    IPersonnelTrainingLoadSuccessAction,

    IPersonnelTrainingCreateAction,
    IPersonnelTrainingCreateFailureAction,
    IPersonnelTrainingCreateSuccessAction,

    IPersonnelTrainingSaveAction,
    IPersonnelTrainingSaveSuccessAction,
    IPersonnelTrainingSaveFailureAction,

    IPersonnelTrainingValidateAction,
    IPersonnelTrainingValidateSuccessAction,
    IPersonnelTrainingValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    ValidateSuccess,
    ValidateFailure,

    CreateSuccess,
    CreateFailure,
    ACTION_PERSONNELTRAINING_LOAD_BY_PERSONNELID,
    IPersonnelTrainingLoadByPersonnelIdAction,

} from "../actions/personnelTraining";
import { personnelTrainingApi } from "../services/personnelTraining";


export const
    getPersonnelTrainingByIdEpic = (action$): Observable<IPersonnelTrainingLoadSuccessAction | IPersonnelTrainingLoadFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNELTRAINING_LOAD_BY_ID)
            .mergeMap((action: IPersonnelTrainingLoadByIdAction) => {
                return personnelTrainingApi
                    .getPersonnelTrainingById(action.id)
                    .map(response =>
                        LoadSuccess(response.personnelTraining, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getPersonnelTrainingsByPersonnelIdEpic = (action$): Observable<IPersonnelTrainingLoadSuccessAction | IPersonnelTrainingLoadFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNELTRAINING_LOAD_BY_PERSONNELID)
            .mergeMap((action: IPersonnelTrainingLoadByPersonnelIdAction) => {
                return personnelTrainingApi
                    .getPersonnelTrainingByPersonnelId(action.personnelId)
                    .map(response =>
                        LoadSuccess(response.personnelTraining, undefined, undefined, undefined, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    createPersonnelTrainingEpic = (action$): Observable<IPersonnelTrainingCreateSuccessAction | IPersonnelTrainingCreateFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNELTRAINING_CREATE)
            .mergeMap((action: IPersonnelTrainingCreateAction) => {
                return personnelTrainingApi
                    .createPersonnelTraining(action.personnelId)
                    .map(response =>
                        CreateSuccess(response.personnelTraining, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    setPersonnelTrainingEpic = (action$): Observable<IPersonnelTrainingSaveSuccessAction | IPersonnelTrainingSaveFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNELTRAINING_SAVE)
            .mergeMap((action: IPersonnelTrainingSaveAction) => {
                return personnelTrainingApi
                    .setPersonnelTraining(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.personnelTraining, response.formState, response.lookups, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    validatePersonnelTrainingEpic = (action$): Observable<IPersonnelTrainingValidateSuccessAction | IPersonnelTrainingValidateFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNELTRAINING_VALIDATE)
            .mergeMap((action: IPersonnelTrainingValidateAction) => {
                return personnelTrainingApi
                    .validatePersonnelTraining(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.personnelTraining, response.formState, response.lookups, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }